var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "资料上传",
        visible: _vm.visible,
        "append-to-body": "",
        width: "50%"
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "orgForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "110px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "资料类型", prop: "type" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    size: "small",
                    clearable: "",
                    placeholder: "请选择"
                  },
                  model: {
                    value: _vm.ruleForm.type,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "type", $$v)
                    },
                    expression: "ruleForm.type"
                  }
                },
                _vm._l(_vm.typeOptions, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "文件上传" } },
            [
              _c(
                "el-upload",
                {
                  ref: "upload",
                  staticClass: "avatar-uploader",
                  attrs: {
                    action: "#",
                    name: "file",
                    accept: "image/jpeg,image/pdg,image/png",
                    disabled: _vm.fileList.length > 0,
                    "on-change": _vm.onChange,
                    "http-request": _vm.upLoadFile,
                    "before-upload": _vm.handleBefore,
                    "auto-upload": false,
                    "on-remove": _vm.handleRemove,
                    "before-remove": _vm.beforeRemove,
                    "file-list": _vm.fileList,
                    multiple: "",
                    limit: 1
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "file",
                        disabled: _vm.fileList.length > 0
                      }
                    },
                    [_vm._v("点击上传")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.submitForm("ruleForm")
                    }
                  }
                },
                [_vm._v("保存")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }